<template>
  <modal
    :active="active"
    :title="creditNote ? 'Kreditér sag' : 'Fakturér sag'"
    @closed="$emit('closed')"
  >
    <div class="p-4 is-flex is-flex-direction-column">
      <input-checkbox
        v-model="economic"
        label="Bogfør sag i e-conomic"
        :disabled="ean"
      />
      <span v-if="ean" class="mt-2">
        Der er angivet EAN-nummer på kunden, automatisk bogføring i e-conomic er ikke muligt.
      </span>
    </div>

    <template v-slot:footer class="has-space-between">
      <div class="footer-spacer">
        <div>
          <button class="button is-default" @click="$emit('closed')">
            Annullér
          </button>
          <button class="button is-primary" @click="$emit('invoice', economic)">Bekræft</button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@elems/modal";
import { FormField, InputCheckbox } from "@elems/form";

export default {
  components: {
    Modal,
    FormField,
    InputCheckbox,
  },
  props: {
    active: Boolean,
    creditNote: Boolean,
    ean: Boolean,
  },
  data() {
    return {
      economic: 1,
    };
  },
  watch: {
    active() {
      if (this.active) {
        this.economic = this.ean ? 0 : 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
